import React from "react";
import { Link } from "react-router-dom";
function About() {
    return (
        <>
            <section className=" inner-banner-sec about_page_banner">
                <div className="container-fluid add-padding-2">
                    <div className="inner-bg-img">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 align-self-center">
                                <div className="banner_text">
                                    <h1>
                                        <span>About Us</span>
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="about-sec inner-about-sec">
                <div className="container-fluid add-padding">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-5 col-sm-12 col-12">
                            <div className="about-img">
                                <img src="images/about.jpg" alt="Enter a Space Curated for Visionaries" />
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-7 col-sm-12 col-12">
                            <div class="about-text">
                                <h2>Enter a Space Curated for Visionaries</h2>
                                <ul>
                                    <li>
                                        <h5>About us</h5>
                                    </li>
                                    <li>
                                        <p></p><p>At The Design Showroom, we believe great design begins with imagination and is brought to life through intention. More than a display space, our concept showroom—rooted in the Luxe Family portfolio—is a curated destination in West London that inspires design professionals and discerning clients alike.</p>

                                        <p>We unite world-renowned brands such as Momenti, Antonio Liso, Top Ciment, JR Stone, and 1810 Sinks, alongside signature collections from Luxe Cucine, Luxe LED, and Luxe Décor by Giorgio Graesan. From artisanal wall finishes and microcement surfaces to modular Italian kitchens and luxury sinks, every product is carefully chosen for its quality, function, and design integrity.</p>

                                        <p>What sets us apart is our commitment to experience, curation, and collaboration. Clients can explore tangible materials, receive expert guidance, and visualize real-world applications—all under one roof. Whether you're crafting a private residence or a landmark commercial space, we offer tailored support and a seamless journey from concept to completion.</p>

                                        <p>Here, luxury isn’t just a look—it’s a feeling, a function, and a process. At The Design Showroom, every detail matters—because extraordinary spaces begin with curated inspiration and end with crafted perfection.</p><p></p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}

export default About;
